import {DatamodelRoles, WorkspaceRoles} from "./UserManager.types";
import {Popover} from "antd";
import {IconContainer} from "@biron-data/react-components";
import React, {ReactNode, useMemo} from "react";
import {
  HandIcon,
  CalendarIcon,
  ChartBarIcon,
  EyeIcon,
  FilterIcon,
  FolderIcon,
  KeyIcon,
  PlusCircleIcon, UsersIcon
} from "@heroicons/react/outline";
import styled from "styled-components";
import Language from "../../../language";
import {TooltipPlacement} from "antd/es/tooltip";


export const getIsWorkspaceReader = (roles?: WorkspaceRoles[]) => Boolean(roles?.includes(WorkspaceRoles.WORKSPACE_READER))
export const getIsWorkspaceWriter = (roles?: WorkspaceRoles[]) => Boolean(roles?.includes(WorkspaceRoles.WORKSPACE_WRITER))
export const getIsWorkspaceManager = (roles?: WorkspaceRoles[]) => Boolean(roles?.includes(WorkspaceRoles.WORKSPACE_MANAGER))


const RoleContainer = styled.div`
    display: flex;
    padding-bottom: 10px;
gap: 10px;
    font-size: 19px;
font-weight: 500;
    justify-content: center;
    width: 100%;
`
const WorkspaceRightsTooltip = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px;
    max-width: 450px;
`

const DetailLine = styled.div<{$includeBorder: boolean}>`
    ${({$includeBorder}) => $includeBorder ? 'border-top: 1px solid var(--border-color-base);' : ''}
    padding-top: 10px;
    display: flex;
    flex-direction: column;
    gap: 5px;
`

const PrimaryDiv = styled.div`
    color: var(--primary);
`
const Required = styled.div`
    font-weight: 600;
    font-size: 12px;
    line-height: 23px;
    text-align: center;
    vertical-align: middle;
    color: var(--primary);
`
const Summary = styled.div`
    font-weight: 400;
    font-style: italic;
    font-size: 14px;
    line-height: 21px;
    text-align: center;
    vertical-align: middle;
`
const FlexDiv = styled.div`
  
  display: flex;
  flex-direction: row;   
  align-items: center;
  gap: 5px;
`

const Footer = styled.div`
    line-height: 21px;
`
export const useWorkspaceReaderDetails = () => useMemo(() => <>
    <FlexDiv><IconContainer><KeyIcon/></IconContainer>{Language.get("admin.user.tooltips.reader.key")}</FlexDiv>
    <FlexDiv><IconContainer><EyeIcon/></IconContainer>{Language.get("admin.user.tooltips.reader.eye")}</FlexDiv>
    <FlexDiv><IconContainer><CalendarIcon/></IconContainer>{Language.get("admin.user.tooltips.reader.calendar")}<PrimaryDiv>*</PrimaryDiv></FlexDiv>
    <FlexDiv><IconContainer><FilterIcon/></IconContainer>{Language.get("admin.user.tooltips.reader.filter")}<PrimaryDiv>**</PrimaryDiv></FlexDiv>
</>, [])

export const useWorkspaceWriterDetails = () => useMemo(() => <>
  <FlexDiv><IconContainer><PlusCircleIcon/></IconContainer>{Language.get("admin.user.tooltips.reader.key")}</FlexDiv>
  <FlexDiv><IconContainer><ChartBarIcon/></IconContainer>{Language.get("admin.user.tooltips.reader.eye")}</FlexDiv>
  <FlexDiv><IconContainer><FolderIcon/></IconContainer>{Language.get("admin.user.tooltips.reader.calendar")}<PrimaryDiv>*</PrimaryDiv></FlexDiv>
  <FlexDiv><IconContainer><HandIcon/></IconContainer>{Language.get("admin.user.tooltips.reader.filter")}<PrimaryDiv>**</PrimaryDiv></FlexDiv>
</>, [])

export const useWorkspaceManagerDetails = () => useMemo(() => <>
  <FlexDiv><IconContainer><UsersIcon/></IconContainer>{Language.get("admin.user.tooltips.manager.users")}</FlexDiv>
</>, [])

